/*
 * groups Reducer
 */
import get from 'lodash.get';

import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from '../scaffoldData/constants';
import { RESET_STATE } from '../auth/constants';
import {
    GROUP_CREATE_SUCCEEDED,
    GROUP_UPDATE_SUCCEEDED,
    GROUP_DELETE_SUCCEEDED
} from './constants';

const initialState = {};

export default function(state = initialState, action) {
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED:
            return get(action, 'payload.entities.groups', {});
        case GROUP_CREATE_SUCCEEDED:
        case GROUP_UPDATE_SUCCEEDED: {
            const groups = get(action, 'payload.entities.groups', {});
            return {
                ...state,
                ...groups
            };
        }
        case GROUP_DELETE_SUCCEEDED: {
            const copy = Object.assign({}, state);
            delete copy[action.id];
            return copy;
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
